import * as React from 'react';
// mui
import {
  ListItemText,
  Typography,
} from '@mui/material';
// icons
import FlagIcon from '@mui/icons-material/Flag';
import NotesIcon from '@mui/icons-material/Notes';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
// redux
import { useSelector } from 'react-redux';
import { selectEventById } from '../../../store/selectors/eventSelectors';
import { selectProjectById } from '../../../store/selectors/projectSelectors';
// types
import Event from '../../../interfaces/Event.interface';
import Project from '../../../interfaces/Project.interface';
// components
import { convertPriorityToString } from '../../common/propertyValueToString';
import ItemContentDate from '../../common/ItemContentDate';

interface EventItemContentProps {
  eventId: number;
  showProject?: boolean;
}

export default function EventItemContent(props: EventItemContentProps) {
  // props
  const { eventId } = props;
  const showProject = props.showProject || false;

  // local constants
  const localEvent: Event = useSelector(selectEventById(eventId)) as Event;
  const localProject: Project = useSelector(selectProjectById(localEvent.projectId)) as Project;

  return (
    <ListItemText
      sx={{color: localEvent.completed || localEvent.excused ? 'grey' : 'inherit'}}
      primary={localEvent.title}
      secondary={
        <Typography
          variant={'caption'}
          sx={{color: localEvent.completed ? 'grey' : '#9e9e9e'}}
        >
          { localEvent.description &&
            <NotesIcon sx={{
              height: '18px',
              width: '20px',
              marginBottom: '-4px',
              mr: '4px'
            }}/>
          }

          <ItemContentDate
            itemData={localEvent}
            itemType="event"
          />

          {/* task info icons */}
          <FlagIcon sx={{
            height: '18px',
            width: '20px',
            marginBottom: '-4px',
            ml: '4px'
          }} />{convertPriorityToString(localEvent.priority)}

          { showProject && (
            <React.Fragment>
              <FolderOpenIcon sx={{
                height: '18px',
                width: '20px',
                marginBottom: '-4px',
                ml: '5px',
                mr: '1px',
              }}/>{localProject.name}
            </React.Fragment>
          )}
        </Typography>
      }
    />
  )
}